import script from "./CodeEditor.vue?vue&type=script&lang=ts&setup=true"
export * from "./CodeEditor.vue?vue&type=script&lang=ts&setup=true"

import "./CodeEditor.vue?vue&type=style&index=0&id=74af79b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74af79b6"]])

export default __exports__